import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import { getMessaging, isSupported, type Messaging } from 'firebase/messaging'

let app: FirebaseApp | null = null

function ensureApp(): FirebaseApp {
  if (app) return app
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY
  const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID
  const storageBucket = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET
  const messagingSenderId = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID
  const appId = import.meta.env.VITE_FIREBASE_APP_ID

  const configOk = apiKey && authDomain && projectId && storageBucket && messagingSenderId && appId
  if (!configOk) {
    throw new Error('Configuração Firebase inválida: verifique variáveis VITE_FIREBASE_*')
  }

  const firebaseConfig = {
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
  }

  app = getApps().length ? getApps()[0]! : initializeApp(firebaseConfig)
  return app
}

export async function getMessagingIfSupported(): Promise<Messaging | null> {
  try {
    if (!(await isSupported())) {
      return null
    }
    const vapidKey = getVapidKey()
    if (!vapidKey) {
      throw new Error('VITE_FIREBASE_VAPID_KEY ausente. Configure antes de solicitar push.')
    }
    return getMessaging(ensureApp())
  } catch (e) {
    console.warn('[firebaseClient] FCM indisponível neste ambiente.', e)
  }
  return null
}

export function getVapidKey(): string | undefined {
  return import.meta.env.VITE_FIREBASE_VAPID_KEY as string | undefined
}
